export default __webpack_public_path__ + "static/media/EUR.546fc2b7.svg";